module.exports = __webpack_public_path__ + "static/media/bg-streaming.de11d38c.mp4";